import type { EcosystemAdminEntry } from '@frontend/types';

export interface RealmEcosystemsListProps {
  ecosystems: EcosystemAdminEntry[];
  selectedEcosystemId: string | null;
  onSelect: (ecosystemId: string) => void;
}

export default function RealmEcosystemsList({
  ecosystems,
  selectedEcosystemId,
  onSelect,
}: RealmEcosystemsListProps) {
  return (
    <ul className="admin-orch-list" aria-label="Realm ecosystems">
      {ecosystems.map((eco) => {
        const selected = selectedEcosystemId === eco.id;
        return (
          <li key={eco.id}>
            <button
              type="button"
              className={`admin-orch-list-row${selected ? ' is-selected' : ''}${
                eco.decommissioned ? ' is-decommissioned' : ''
              }`}
              onClick={() => onSelect(eco.id)}
              aria-pressed={selected}
            >
              {eco.displayName || eco.id}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
